import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useI18n } from '../../contexts/I18nContext';
import { localizePath } from '../../utils/localePaths';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const { lang } = useI18n();
  const location = useLocation();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  if (!isAuthenticated) return <Navigate to={localizePath('/login', lang)} state={{ from: location }} replace />;
  return children;
}
